import type { SVGProps } from "react";

export type IconProps = SVGProps<SVGSVGElement>;

/** Shared attributes for the decorative inline icons. */
export const svgDefaults = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": true,
  focusable: "false",
} as const;
